import TooltipWrapper from "@UI/New/TooltipWrapper/TooltipWrapper";
import { MessagaChatIcon } from "@/utils/icons";

const OpenPrivateChatButton = ({ className, onClick, iconWidth = 20, iconHeight = 20 }) => {
    return (
        <TooltipWrapper title='Написать в ЛС'>
            <div className={className} onClick={onClick}>
                <MessagaChatIcon width={iconWidth} height={iconHeight} />
            </div>
        </TooltipWrapper>
    );
};

export default OpenPrivateChatButton;
